module.exports = __webpack_public_path__ + "static/img/equ1a.c4c446c1.png";